<template>
  <div>
    <div class="card">
      <div class="card-body">
        <b-table hover small responsive show-empty
                 style="font-size:1em;"
                 :fields="fields"
                 :items="lifecycleMetrics"
                 :busy="isLoading">
<!--          <template v-slot:cell(onHoldPercentage)="row">
            {{data.items.onHoldPercentage}}%
          </template>-->
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
          <template #table-caption></template>

          <template v-slot:empty="scope">
            <p>No data found</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import {statusOptions} from "@/mixins/statusOptions";

export default {
  components: {},
  mixins: [
    statusOptions
  ],
  props: {partitionType: String},
  data() {
    return {
      isLoading: true,
      lifecycleMetrics: [],
    }
  },
  computed: {
    fields: function () {
      let results = []
      if (this.partitionType === 'Fiscal Year') {
        results.push({key: 'partition', sortable: true, label: 'Fiscal Year'})
      } else {
        results.push({key: 'partition', sortable: true, label: 'Division'})
      }
        results.push({key: `completedCount`, sortable: true, label: 'Quantity Completed'})
        results.push({key: `average`, sortable: true, label: 'Average Time to Complete (Days)'})
        // results.push({key: `onHoldPercentage`, sortable: true, label: 'Percentage on Hold'})
      return results
    }
  },
  created() {
    this.isLoading = true
    this.loadHiringStageSummary();
  },
  watch: {},
  methods: {
    loadHiringStageSummary() {
      if (this.partitionType === 'Fiscal Year') {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/completedVacancyByFiscalYear`)
            .then(response => {
              this.lifecycleMetrics = this.processData(response.data)
              console.log("Completed Vacancy Fiscal Year")
              console.log(response.data)
              this.isLoading = false
            })
      } else if (this.partitionType === 'Division') {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/completedVacancyByDivision`)
            .then(response => {
              this.lifecycleMetrics = this.processData(response.data)
              console.log("Completed Vacancy By Division")
              console.log(response.data)
              this.isLoading = false
            })
      }
    },
    processData(data) {
      data.forEach(row => {
            row.average = row.average.toFixed(2)
            // console.log(row.onHoldPercentage)
            // if (row.onHoldPercentage && row.onHoldPercentage != 0) {
            //   row.onHoldPercentage = row.onHoldPercentage.toFixed(2)
            // }
          }
      )
      return data
    },
  }
}
</script>